<template>
  <header class="text-white py-3">
    <div class="container">
      <nav class="d-flex justify-content-center">
        <router-link to="/" class="text-white mx-3">HOME</router-link>
        <a href="https://woocommerce.6footspeakeasy.com/" rel="noopener noreferrer" class="text-white mx-3">SHOP</a>
        <router-link to="/article-archives" class="text-white mx-3">ARTICLE ARCHIVES</router-link>
        <a href="https://www.archives.gov" target="_blank" rel="noopener noreferrer" class="text-white mx-3">NATIONAL ARCHIVES</a>
        <router-link to="/about" class="text-white mx-3">ABOUT</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderSection",
};
</script>

<style scoped>
a:hover {
  text-decoration: underline;
}
</style>
